module.exports = __webpack_public_path__ + "static/ipad-737a74fe1146934cfc39d83018ee22cb.png";